import React from "react";

export const PageNotFound = () => {
  return <h2>Page NotFound</h2>;
};
